import React, { FC } from 'react';
import { toast } from 'react-toastify';
import {
  ActionButton,
  ElementHeader,
  MaterialIcon,
  PermissionBoundary,
} from '../../../../components';
import { Surcharge } from '../../../../models';
import { useTranslation } from '../../../../translations';
import { surchargeRateText, SurchargeTitle } from '../../surcharges/utils';

interface Props {
  readonly categoryId: number;
  readonly surcharge: Surcharge;
  readonly refresh: () => void;
}

export const CategorySurchargeItem: FC<Props> = ({ categoryId, surcharge, refresh }) => {
  const { ts } = useTranslation();
  return (
    <ElementHeader
      icon={{ iconName: 'local_atm' }}
      key={surcharge.id}
      rightContent={
        <PermissionBoundary
          inline
          requiredPermissions={['product:category:manage', 'product:manage']}
        >
          <ActionButton
            action={async () => {
              await api.deleteCategorySurcharge(categoryId, surcharge.id);
            }}
            className="action-delete"
            color="danger"
            onSuccess={() => {
              toast.success(ts('removed_category_level_surcharge_surchargename', surcharge.name));
              refresh();
            }}
            outline
            title={ts('common.delete')}
          >
            <MaterialIcon name="delete" />
          </ActionButton>
        </PermissionBoundary>
      }
      title={surcharge.name}
    >
      <SurchargeTitle surcharge={surcharge} /> {ts('common.of')}
      {surchargeRateText(surcharge)}
    </ElementHeader>
  );
};
